import { render, staticRenderFns } from "./DownCon.vue?vue&type=template&id=27bc1f6c&scoped=true"
import script from "./DownCon.vue?vue&type=script&lang=js"
export * from "./DownCon.vue?vue&type=script&lang=js"
import style0 from "./DownCon.vue?vue&type=style&index=0&id=27bc1f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bc1f6c",
  null
  
)

export default component.exports